module.exports = __webpack_public_path__ + "img/arrows-up-down-dark-green.4ba7ae5f.svg";